import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { SubheaderService } from '../core/_base/layout';
import { MenuCategoryModel } from '../views/models/menu-category.model';
import { MenuItemModel } from '../views/models/menu-item.model';
import { MenuSectionModel } from '../views/models/menu-section.model';
import { AWSService } from './aws.service';
import { CatalogueService } from './catalogue.service';
import { MenuService } from './menu.service';
import { PoisService } from './pois.service';
import { UserService } from './user.service';

export class Category {
  category: MenuCategoryModel;
  items: MenuItemModel[];

  constructor(
    category = new MenuCategoryModel(),
    items = []
  ) {
    this.category = category;
    this.items = items;
  }
}

@Injectable()
export class MenuSectionService {
  section_change$ = new BehaviorSubject<MenuSectionModel>(new MenuSectionModel());
  menuDatas: MenuItemModel[];
  record_change$ = new BehaviorSubject<Category[]>([]);
  dialag_change = new BehaviorSubject<{
    section_id: number,
    section_name: string,
    description: string,
    items: { img: string, name: string }[]
  } | undefined>(undefined);

  constructor(
    private httpClient: HttpClient,
    private subheaderService: SubheaderService,
    private menuService: MenuService,
    private router: Router,
    private poisService: PoisService,
    private awsService: AWSService,
    private userService: UserService,
    private catalogueService: CatalogueService
  ) {
  }

  getDatas(menuSectionID: number) {

    return new Promise((resolve, reject) => {
      this.record_change$.next([]);
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_section/' + menuSectionID).subscribe(
        (data: MenuSectionModel) => {
          this.subheaderService.breadcrumbs$.next([{ title: 'Home', page: '/home' }]);
          if (data.title.search('POIs') != -1) {
            if (localStorage.getItem('range') == null) {
              localStorage.setItem('range', '3000');
              this.poisService.googlePlaceApi(3000);
            } else {
              this.poisService.googlePlaceApi(+localStorage.getItem('range'));
            }
            this.subheaderService.title$.next({ title: data.title, desc: '', po_is: true });
          } else {
            this.subheaderService.title$.next({ title: data.title, desc: '' });
          }
          this.section_change$.next(data);
        }
      );

      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item_section/' + menuSectionID).subscribe(
        (datas: MenuItemModel[]) => {
          this.menuDatas = datas;
          this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_category/' + menuSectionID).subscribe(
            (categories: MenuCategoryModel[]) => {
              if (categories.length == 1) {
                if (categories[0].menu_item_id != 0) {
                  this.router.navigateByUrl('/home/menu-item/' + categories[0].menu_item_id).then();
                  return;
                }
              }
              let data: Category[] = [];
              for (const item of categories) {
                const newCategory: Category = new Category();
                newCategory.category = item;
                newCategory.items = this.menuDatas.filter(x => x.menu_category_id == item.id);
                newCategory.items = newCategory.items.sort((a, b) => a.priority - b.priority);
                data.push(newCategory);
              }
              // category sort by id
              data = data.sort((a, b) => a.category.id - b.category.id);
              this.record_change$.next(data);
              resolve(data);
            }
          );
        }
      );
    });
  }

  getSectionByID(sectionID: number) {
    return this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_section/' + sectionID);
  }

  getSectionByIdPromise(sectionID: number) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_section/' + sectionID).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  getAllSections() {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_section').subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  setData(data: MenuItemModel, newCategoryID: number) {
    // console.log(data);
    const datas = this.record_change$.getValue();
    if (data.id == 0) {
      const dataIndex = datas.findIndex(x => x.category.id == newCategoryID);
      data.menu_section_id = datas[dataIndex].category.menu_section_id;
      data.menu_category_id = datas[dataIndex].category.id;
      datas[dataIndex].items.push(data);
      const changeValue: MenuItemModel[] = [data];
      this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_item/' + data.menu_section_id + '/' + data.menu_category_id, changeValue).subscribe(
        () => {
        },
        (err) => console.log(err),
        () => {
          this.getDatas(data.menu_section_id);
        }
      );
    } else {
      const findIndex = datas.findIndex(x => x.category.id == data.menu_category_id);
      const index = datas[findIndex].items.findIndex(x => x.id == data.id);
      datas[findIndex].items.splice(index, 1);
      data.menu_category_id = newCategoryID;
      datas.find(x => x.category.id == newCategoryID).items.push(data);
      const changeValue: MenuItemModel[] = [data];
      this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_item', changeValue).subscribe(
        () => {
        },
        (err) => console.log(err),
        () => {
          this.record_change$.next(datas);
        }
      );
    }
  }

  postData(data: MenuItemModel, categoryID: number) {
    const datas = this.record_change$.getValue();
    const dataIndex = datas.findIndex(x => x.category.id == categoryID);
    data.menu_section_id = datas[dataIndex].category.menu_section_id;
    data.menu_category_id = datas[dataIndex].category.id;
    datas[dataIndex].items.push(data);
    const changeValue: MenuItemModel[] = [data];
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_item/' + data.menu_section_id + '/' + data.menu_category_id, changeValue);
  }

  setPoisItems(datas: MenuItemModel[], newCategoryID: number, sectionId) {
    // console.log(datas);
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_item/' + sectionId + '/' + newCategoryID, datas);
  }

  deleteData(data: MenuItemModel) {
    this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Items', data.id);
    this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog');

    const datas = this.record_change$.getValue();
    const categoryIndex = datas.findIndex(x => x.category.id == data.menu_category_id);
    const dataIndex = datas[categoryIndex].items.findIndex(x => x.id == data.id);
    datas[categoryIndex].items.splice(dataIndex, 1);
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_item/' + data.id).subscribe(
      () => {
      },
      (err) => console.log(err),
      () => {
        this.record_change$.next(datas);
        // item image silme İşlemleri
        this.awsService.image_change$.getValue().forEach(x => {
          console.log(x.file_name);
          this.awsService.deleteImage(this.userService.record_change$.getValue().app_hotel_id, 'Items', x.file_name).subscribe();
        });

        // Catalog Image Silme İşleri
        this.catalogueService.getData(data.id);
        this.catalogueService.record_change$.subscribe(
          (resp) => {
            const catalogs = resp;
            catalogs.forEach(x => {
              x.items.forEach(y => {
                const catalogImages = this.awsService.catalogImage_change$.getValue();
                catalogImages.forEach(z => {
                  if (y.id == +z.file_name.split('_')[0] && y.menu_item_id == data.id) {
                    console.log('item catalog image silindi');
                    this.awsService.deleteImage(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', z.file_name).subscribe();
                  }
                });
              });
            });
          }
        );

      }
    );
  }

  addCategory(title: string, menuSectionID: number) {
    const category: MenuCategoryModel = new MenuCategoryModel(0, menuSectionID, title);
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_category', category).subscribe(
      () => {
      },
      (err) => console.log(err),
      () => {
        this.getDatas(menuSectionID);
      }
    );
  }

  addCategoryRet(title: string, menuSectionID: number) {
    const category: MenuCategoryModel = new MenuCategoryModel(0, menuSectionID, title);
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_category', category);
  }

  putCategory(data: MenuCategoryModel) {
    if (data.id != 0) {
      this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_category/' + data.id, data).subscribe(
        () => {
        },
        (err) => console.log(err)
      );
    }
  }

  deleteCategory(data: Category, i: number) {
    const datas = this.record_change$.getValue();
    const index = datas.findIndex(x => x.category.id == data.category.id);
    if (i == 1) {
      data.items.forEach(x => {
        this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_item/' + x.id).subscribe(
          () => {
          },
          (err) => console.log(err)
        );
      });

      datas.splice(index, 1);
      this.record_change$.next(datas);
      this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_category/' + data.category.menu_section_id + '/' + data.category.id).subscribe();
      return;
    }
    if (datas[index].items.length > 0 && i == 0) {
      let changeDatas: MenuItemModel[];
      if (index == 0) {
        datas[index].items.forEach(x => x.menu_category_id = datas[1].category.id);
        datas[1].items.push(...datas[index].items);
      } else {
        datas[index].items.forEach(x => x.menu_category_id = datas[0].category.id);
        datas[0].items.push(...datas[index].items);
      }
      changeDatas = datas[index].items;
      this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_item', changeDatas).subscribe(
        () => {
        },
        (err) => console.log(err),
        () => {
          datas.splice(index, 1);
          this.record_change$.next(datas);
          this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_category/' + data.category.menu_section_id + '/' + data.category.id).subscribe();
        }
      );
    }
    if (datas[index].items.length == 0 || i == 1) {
      datas.splice(index, 1);
      this.record_change$.next(datas);
      this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_category/' + data.category.menu_section_id + '/' + data.category.id).subscribe();
    }
  }

  putSection(section: MenuSectionModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_section/' + section.id, section).subscribe(
      () => {
      },
      error => console.log(error),
      () => this.menuService.getMenu()
    );
  }

  getDialogData(sectionID: number) {
    this.httpClient.get('./assets/DefaultItems.json').subscribe(
      (datas: { section_id: number, section_name: string, description: string, items: { img: string, name: string }[] }[]) => {
        const data = datas.find(x => x.section_id == sectionID);
        this.dialag_change.next(data);
      }
    );
  }

  postSection(section: MenuSectionModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_section', section).subscribe(
      () => {
      },
      error => console.log(error),
      () => this.menuService.getMenu()
    );
  }
}
